import { TriggerType } from "../interfaces/flow/trigger/TriggerType";

export const newScheduledTrigger = (value: string):any  => {
  return { type:TriggerType.SCHEDULED_TRIGGER_TYPE,value:value };
};
export const newWebhookTrigger = (value: string):any  => {
  return { type:TriggerType.CUSTOM_WEBHOOK_TRIGGER_TYPE,value:value };
};
export const newAtlassianWebhookTrigger = (value: string, jqlFilter: string, events:[], projectIds: string[] = []):any  => {
  return { type:TriggerType.ATLASSIAN_WEBHOOK_TRIGGER_TYPE,value:value, config:{jqlFilter:jqlFilter,events:events,projectIds:projectIds } };
};
